/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Publiclabel1Inputs */

const zh_learn_publiclabel1 = /** @type {(inputs: Learn_Publiclabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开`)
};

const en_learn_publiclabel1 = /** @type {(inputs: Learn_Publiclabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const es_learn_publiclabel1 = /** @type {(inputs: Learn_Publiclabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Learn_Publiclabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_publiclabel1 = /** @type {((inputs?: Learn_Publiclabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Publiclabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_publiclabel1(inputs)
	if (locale === "en") return en_learn_publiclabel1(inputs)
	return es_learn_publiclabel1(inputs)
});
export { learn_publiclabel1 as "learn_publicLabel" }